import React from 'react';
import '../styles/AgentSpotlight.css';
// Import images with fallback
let influencerImage, socialImage;
try {
  influencerImage = require('../assets/influencer-agent.png');
} catch (e) {
  influencerImage = null;
}
try {
  socialImage = require('../assets/social-agent.png');
} catch (e) {
  socialImage = null;
}

const AgentSpotlight = ({ title, description, imageUrl, reversed, onInteract }) => {
  // Use imported images or fallback to a blank placeholder
  const getImage = () => {
    if (title.includes("Influencer")) {
      return influencerImage || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
    } else if (title.includes("Social")) {
      return socialImage || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
    } else {
      return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
    }
  };

  // Track interactions with this spotlight section
  const handleInteraction = () => {
    if (onInteract) {
      onInteract();
    }
  };

  return (
    <section 
      className={`agent-spotlight ${reversed ? 'reversed' : ''}`}
      onClick={handleInteraction}
    >
      <div className="container">
        <div className="spotlight-content">
          <div className="spotlight-text">
            <h2>{title}</h2>
            <p className="spotlight-description">{description}</p>
            
            <div className="spotlight-features">
              {title.includes("Influencer") ? (
                <>
                  <div className="feature-item">
                    <div className="feature-icon">🔍</div>
                    <div className="feature-text">
                      <h4>Find Perfect Affiliates</h4>
                      <p>AI-powered matching to find the most relevant influencers for your niche</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">📝</div>
                    <div className="feature-text">
                      <h4>Automate Outreach</h4>
                      <p>Generate personalized outreach messages that convert</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">📊</div>
                    <div className="feature-text">
                      <h4>Track Performance</h4>
                      <p>Monitor affiliate sales, commissions, and performance in real-time</p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="feature-item">
                    <div className="feature-icon">🎬</div>
                    <div className="feature-text">
                      <h4>Multi-Platform Content</h4>
                      <p>Create platform-specific content for each social network</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">⏱️</div>
                    <div className="feature-text">
                      <h4>Smart Scheduling</h4>
                      <p>AI determines the optimal posting times for maximum engagement</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">💬</div>
                    <div className="feature-text">
                      <h4>Engagement Automation</h4>
                      <p>Let AI handle comments and messages while maintaining your brand voice</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          
          <div className="spotlight-image">
            <img src={getImage()} alt={title} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentSpotlight;
